import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

let initialized = false

router.beforeEach(async () => {
  if (initialized)
    return true
  initialized = true

  // 动态导入，避免循环依赖
  const { useUserStore, getToken } = await import('./stores/user')
  const { useAttribution } = await import('./composables/useAttribution')
  const { usePageStore } = await import('./stores/page')

  // 延迟到 pinia 已挂载时再获取 store（router.beforeEach 在 app.use(router) 前执行时 pinia 可能未就绪）
  // 通过 try/catch 安全处理
  try {
    const userStore = useUserStore()
    const pageStore = usePageStore()

    if (!getToken()) {
      // 未登录：收集归因参数后自动匿名登录
      const { init } = useAttribution()
      const attributionRequest = await init()
      await userStore.login(attributionRequest)
      await userStore.fetchUserInfo()
    }
    else {
      // 已有 token：拉取用户信息
      await userStore.fetchUserInfo()
    }

    // 预加载首页 pageList
    if (!pageStore.pageList.length) {
      const { getPageList } = await import('./api/home')
      const list = await getPageList()
      pageStore.setPageList(list)
    }
  }
  catch (e) {
    console.error('[router] init error', e)
  }

  return true
})

router.afterEach((to, from) => {
  // 设置 prevPage（用于后续埋点携带）
  if (from.name && from.meta?.title) {
    import('./stores/history').then(({ useHistoryStore }) => {
      const historyStore = useHistoryStore()
      historyStore.setPrevPage(
        from.meta.title as string,
        window.location.origin,
        window.location.origin + from.fullPath,
      )
    })
  }

  // 页面浏览埋点
  import('./composables/tracks/usePageView').then(({ pageViewTrack, setPageViewParams }) => {
    if (to.name)
      pageViewTrack(setPageViewParams(to.name as string, to.path))
  })

  // Clarity 事件上报
  if (window.clarity) {
    window.clarity('event', to.name)
    window.clarity('set', 'route', to.name)
  }
})
